import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiNewsFeedAddPostMobileComponent } from '@fi-app/news-feed/news-feed-add-post-mobile/news-feed-add-post-mobile.component';

// todo: remove state once FI-2711 completed. Posts get written in the app directly
export const FiAddPostMobileAppState: Ng2StateDeclaration = {
    name: 'AddPostMobileApp',
    url: '/AddPostMobileApp/',
    component: FiNewsFeedAddPostMobileComponent,
    resolve: {
        pageTitle: [PageTitleService, FiAddPostMobileAppStateResolve_pageTitle],
    },
};

export function FiAddPostMobileAppStateResolve_pageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitle('Add Post Mobile App');
}
